import {Injectable} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {PaymentHistoryFormType} from "./PaymentHistoryFormType";

@Injectable({
    providedIn: 'root',
})
export class PaymentHistoryFormFactory {
    create(): FormGroup<PaymentHistoryFormType> {
        return new FormGroup<PaymentHistoryFormType>({
            searchBy: new FormControl(""),
            isSuccess: new FormControl(null),
            transactionType: new FormControl(null),
            invoiceGenerated: new FormControl(null),
            dateTimeInterval: new FormGroup({
                startDate: new FormControl(null),
                endDate: new FormControl(null),
            }),
        });
    }
}
